// SSML and audio-direction tags in challenges.json are performance
// markup — they steer the ElevenLabs voice model, not the reader. Strip
// them before rendering wilman_text in the UI. Audio renders go via the
// API which preserves them, so the spec rule "Wilman's voice is sacred
// — render verbatim" still holds: same input, different surfaces.

const BREAK_TAG = /<break\s+time="[^"]*"\s*\/?>/gi;
const DIRECTION_TAG = /\[(deadpan|scoffs|muttering|sigh|sighs|chuckles|whispers|softly|loudly|sarcastic|amused|annoyed|resigned|pause)\]/gi;

export function cleanWilmanText(text) {
  if (!text) return '';
  return text
    .replace(BREAK_TAG, ' ')
    .replace(DIRECTION_TAG, '')
    .replace(/\s+([.,;!?])/g, '$1') // remove space before punctuation introduced by break removal
    .replace(/\s{2,}/g, ' ')
    .trim();
}
